export const getApiKey = (organization, vendorApiProfileId) =>
  `/api/v1/organizations/${organization.id}/vendor_api_profiles/${vendorApiProfileId}/api_key`;
export const getWebhookSecret = (organization, vendorApiProfileId) =>
  `/api/v1/organizations/${organization.id}/vendor_api_profiles/${vendorApiProfileId}/webhook_secret`;
export const vendorApiProfiles = (organization) => `/api/v1/organizations/${organization.id}/vendor_api_profiles`;
export const vendorApiProfile = (organization, vendorApiProfileId) =>
  `/api/v1/organizations/${organization.id}/vendor_api_profiles/${vendorApiProfileId}`;
